import React from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES } from '../config/categories';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();
  // Exclude the 'all' (Home) category from footer topics list
  const topicCategories = CATEGORIES.filter((c) => c.id !== 'all');

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">

        {/* Brand Column */}
        <div className="footer-brand">
          <Link to="/" className="footer-logo" aria-label="DailyTechTrend Home">
            <span role="img" aria-label="DailyTechTrend" style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
              <img style={{ height: '48px', width: '80px', objectFit: 'contain' }} src="/DTT_Logo.png" alt="DailyTechTrend Logo" width="80" height="48" loading="lazy" />
            </span>
            <span>DailyTechTrend</span>
          </Link>
          <p className="footer-description">
            Daily tech insights on AI tools, tech guides, money-making strategies, comparisons, and emerging tech trends.
          </p>
        </div>

        {/* Topics Column */}
        <nav className="footer-nav" aria-label="Topic categories">
          <h4 className="footer-heading">Topics</h4>
          <ul className="footer-links">
            {topicCategories.map((cat) => (
              <li key={cat.id}>
                <Link to={`/category/${cat.id}`}>{cat.name}</Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Site Links Column */}
        <nav className="footer-nav" aria-label="Site navigation">
          <h4 className="footer-heading">Site</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        {/* Social Column */}
        <div className="footer-meta">
          <h4 className="footer-heading">Stay Connected</h4>
          <ul className="social-links">
            <li><a href="https://x.com/deepneuralaidna" target="_blank" rel="noopener noreferrer">Twitter / X</a></li>
            <li><a href="https://www.linkedin.com/company/deepneuralai/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        <p>© {year} DailyTechTrend. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
